/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.8.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class CancelReasonClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param salesorgid (optional) 
     * @return Success
     */
    getCancelReasons(salesorgid: number | undefined , cancelToken?: CancelToken | undefined): Promise<CancelReason[]> {
        let url_ = this.baseUrl + "/api/CancelReason/GetCancelReasons?";
        if (salesorgid === null)
            throw new Error("The parameter 'salesorgid' cannot be null.");
        else if (salesorgid !== undefined)
            url_ += "salesorgid=" + encodeURIComponent("" + salesorgid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCancelReasons(_response);
        });
    }

    protected processGetCancelReasons(response: AxiosResponse): Promise<CancelReason[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CancelReason.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CancelReason[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancelReason[]>(<any>null);
    }
}

export class CMMFClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param salesorgid (optional) 
     * @return Success
     */
    searchCMMFs(salesorgid: number | undefined , cancelToken?: CancelToken | undefined): Promise<CMMF[]> {
        let url_ = this.baseUrl + "/api/CMMF/SearchCMMFs?";
        if (salesorgid === null)
            throw new Error("The parameter 'salesorgid' cannot be null.");
        else if (salesorgid !== undefined)
            url_ += "salesorgid=" + encodeURIComponent("" + salesorgid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCMMFs(_response);
        });
    }

    protected processSearchCMMFs(response: AxiosResponse): Promise<CMMF[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CMMF.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CMMF[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CMMF[]>(<any>null);
    }

    /**
     * @param salesOrgId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadCmmfs(salesOrgId: number | undefined, file: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<SelectedCMMFImportResult> {
        let url_ = this.baseUrl + "/api/CMMF/UploadCmmfs?";
        if (salesOrgId === null)
            throw new Error("The parameter 'salesOrgId' cannot be null.");
        else if (salesOrgId !== undefined)
            url_ += "salesOrgId=" + encodeURIComponent("" + salesOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCmmfs(_response);
        });
    }

    protected processUploadCmmfs(response: AxiosResponse): Promise<SelectedCMMFImportResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelectedCMMFImportResult.fromJS(resultData200);
            return Promise.resolve<SelectedCMMFImportResult>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectedCMMFImportResult>(<any>null);
    }
}

export class CustomerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param salesOrgId (optional) 
     * @return Success
     */
    getAll(salesOrgId: number | undefined , cancelToken?: CancelToken | undefined): Promise<Customer[]> {
        let url_ = this.baseUrl + "/api/Customer/GetAll?";
        if (salesOrgId === null)
            throw new Error("The parameter 'salesOrgId' cannot be null.");
        else if (salesOrgId !== undefined)
            url_ += "salesOrgId=" + encodeURIComponent("" + salesOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Customer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Customer[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Customer[]>(<any>null);
    }

    /**
     * @param option (optional) 0 = MY_WORKLIST
    
    1 = MY_PROMOTION
    
    2 = ALL
     * @return Success
     */
    getAllWithPromotion(option: EPromotionListOption | undefined , cancelToken?: CancelToken | undefined): Promise<Customer[]> {
        let url_ = this.baseUrl + "/api/Customer/GetAllWithPromotion?";
        if (option === null)
            throw new Error("The parameter 'option' cannot be null.");
        else if (option !== undefined)
            url_ += "option=" + encodeURIComponent("" + option) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllWithPromotion(_response);
        });
    }

    protected processGetAllWithPromotion(response: AxiosResponse): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Customer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Customer[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Customer[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomer(body: Customer | undefined , cancelToken?: CancelToken | undefined): Promise<Customer> {
        let url_ = this.baseUrl + "/api/Customer/UpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: AxiosResponse): Promise<Customer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Customer.fromJS(resultData200);
            return Promise.resolve<Customer>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Customer>(<any>null);
    }

    /**
     * @param salesOrgId (optional) 
     * @param file (optional) 
     * @return No Content
     */
    importCsvForUpdateMLA(salesOrgId: number | undefined, file: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Customer/ImportCsvForUpdateMLA?";
        if (salesOrgId === null)
            throw new Error("The parameter 'salesOrgId' cannot be null.");
        else if (salesOrgId !== undefined)
            url_ += "salesOrgId=" + encodeURIComponent("" + salesOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCsvForUpdateMLA(_response);
        });
    }

    protected processImportCsvForUpdateMLA(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class DelegationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getDelegations(userId: number | undefined , cancelToken?: CancelToken | undefined): Promise<Delegation[]> {
        let url_ = this.baseUrl + "/api/Delegation/GetDelegations?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDelegations(_response);
        });
    }

    protected processGetDelegations(response: AxiosResponse): Promise<Delegation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Delegation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Delegation[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Delegation[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSurrogacies(  cancelToken?: CancelToken | undefined): Promise<UserInformations[]> {
        let url_ = this.baseUrl + "/api/Delegation/GetSurrogacies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurrogacies(_response);
        });
    }

    protected processGetSurrogacies(response: AxiosResponse): Promise<UserInformations[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInformations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserInformations[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations[]>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getSurrogates(userId: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserInformations[]> {
        let url_ = this.baseUrl + "/api/Delegation/GetSurrogates?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurrogates(_response);
        });
    }

    protected processGetSurrogates(response: AxiosResponse): Promise<UserInformations[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInformations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserInformations[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: DelegationsUpdate | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Delegation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class LoginClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginParameter | undefined , cancelToken?: CancelToken | undefined): Promise<AuthentificationResult> {
        let url_ = this.baseUrl + "/api/Login/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthentificationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthentificationResult.fromJS(resultData200);
            return Promise.resolve<AuthentificationResult>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthentificationResult>(<any>null);
    }
}

export class PromotionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postPromotion(body: PromotionInput | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Promotion/PostPromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostPromotion(_response);
        });
    }

    protected processPostPromotion(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<number>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putPromotion(body: PromotionInput | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Promotion/PutPromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutPromotion(_response);
        });
    }

    protected processPutPromotion(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePromotionDp(body: UpdatePossibleDp | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Promotion/UpdatePromotionDp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePromotionDp(_response);
        });
    }

    protected processUpdatePromotionDp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePromotionSnp(body: UpdatePossibleSnp | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Promotion/UpdatePromotionSnp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePromotionSnp(_response);
        });
    }

    protected processUpdatePromotionSnp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePromotionById(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Promotion/DeletePromotionById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePromotionById(_response);
        });
    }

    protected processDeletePromotionById(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPromotion(  cancelToken?: CancelToken | undefined): Promise<Worklist[]> {
        let url_ = this.baseUrl + "/api/Promotion/GetAllPromotion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPromotion(_response);
        });
    }

    protected processGetAllPromotion(response: AxiosResponse): Promise<Worklist[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Worklist.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Worklist[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Worklist[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMyWorklist(  cancelToken?: CancelToken | undefined): Promise<Worklist[]> {
        let url_ = this.baseUrl + "/api/Promotion/GetMyWorklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyWorklist(_response);
        });
    }

    protected processGetMyWorklist(response: AxiosResponse): Promise<Worklist[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Worklist.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Worklist[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Worklist[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMyPromotionList(  cancelToken?: CancelToken | undefined): Promise<Worklist[]> {
        let url_ = this.baseUrl + "/api/Promotion/GetMyPromotionList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyPromotionList(_response);
        });
    }

    protected processGetMyPromotionList(response: AxiosResponse): Promise<Worklist[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Worklist.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Worklist[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Worklist[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<PromotionInput> {
        let url_ = this.baseUrl + "/api/Promotion/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<PromotionInput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PromotionInput.fromJS(resultData200);
            return Promise.resolve<PromotionInput>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PromotionInput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setStatus(body: StatusChangeUpdate | undefined , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Promotion/SetStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetStatus(_response);
        });
    }

    protected processSetStatus(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPromotionWithFilter(body: PromotionListFilter | undefined , cancelToken?: CancelToken | undefined): Promise<Worklist[]> {
        let url_ = this.baseUrl + "/api/Promotion/GetPromotionWithFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPromotionWithFilter(_response);
        });
    }

    protected processGetPromotionWithFilter(response: AxiosResponse): Promise<Worklist[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Worklist.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Worklist[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Worklist[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clonePromotion(body: number | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Promotion/ClonePromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClonePromotion(_response);
        });
    }

    protected processClonePromotion(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<number>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param promotionId (optional) 
     * @return Success
     */
    obtainLock(promotionId: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Promotion/ObtainLock?";
        if (promotionId === null)
            throw new Error("The parameter 'promotionId' cannot be null.");
        else if (promotionId !== undefined)
            url_ += "promotionId=" + encodeURIComponent("" + promotionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processObtainLock(_response);
        });
    }

    protected processObtainLock(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param promotionId (optional) 
     * @param forceRelease (optional) 
     * @return Success
     */
    releaseLock(promotionId: number | undefined, forceRelease: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Promotion/ReleaseLock?";
        if (promotionId === null)
            throw new Error("The parameter 'promotionId' cannot be null.");
        else if (promotionId !== undefined)
            url_ += "promotionId=" + encodeURIComponent("" + promotionId) + "&";
        if (forceRelease === null)
            throw new Error("The parameter 'forceRelease' cannot be null.");
        else if (forceRelease !== undefined)
            url_ += "forceRelease=" + encodeURIComponent("" + forceRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReleaseLock(_response);
        });
    }

    protected processReleaseLock(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param type (optional) 0 = NORMAL
    
    1 = BU
     * @param body (optional) 
     * @return Success
     */
    getExcelPromotions(type: EDownloadPromotionType | undefined, body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Promotion/GetExcelPromotions?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExcelPromotions(_response);
        });
    }

    protected processGetExcelPromotions(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param overrideTodayDate (optional) 
     * @return Success
     */
    getExcelPromotionsAPO(overrideTodayDate: Date | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Promotion/GetExcelPromotionsAPO?";
        if (overrideTodayDate === null)
            throw new Error("The parameter 'overrideTodayDate' cannot be null.");
        else if (overrideTodayDate !== undefined)
            url_ += "overrideTodayDate=" + encodeURIComponent(overrideTodayDate ? "" + overrideTodayDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExcelPromotionsAPO(_response);
        });
    }

    protected processGetExcelPromotionsAPO(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param overrideTodayDate (optional) 
     * @return Success
     */
    getExcelPromotionsONine(overrideTodayDate: Date | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Promotion/GetExcelPromotionsONine?";
        if (overrideTodayDate === null)
            throw new Error("The parameter 'overrideTodayDate' cannot be null.");
        else if (overrideTodayDate !== undefined)
            url_ += "overrideTodayDate=" + encodeURIComponent(overrideTodayDate ? "" + overrideTodayDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExcelPromotionsONine(_response);
        });
    }

    protected processGetExcelPromotionsONine(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importExcelPromotions(file: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Promotion/ImportExcelPromotions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcelPromotions(_response);
        });
    }

    protected processImportExcelPromotions(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @param reasonId (optional) 
     * @param token (optional) 
     * @return Success
     */
    massCancel(ids: string | undefined, reasonId: number | undefined, token: string | undefined , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Promotion/MassCancel?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        if (reasonId === null)
            throw new Error("The parameter 'reasonId' cannot be null.");
        else if (reasonId !== undefined)
            url_ += "reasonId=" + encodeURIComponent("" + reasonId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassCancel(_response);
        });
    }

    protected processMassCancel(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class SalesOrgClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSalesOrg(  cancelToken?: CancelToken | undefined): Promise<SalesOrgDto[]> {
        let url_ = this.baseUrl + "/api/SalesOrg/GetAllSalesOrg";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSalesOrg(_response);
        });
    }

    protected processGetAllSalesOrg(response: AxiosResponse): Promise<SalesOrgDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOrgDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOrgDto[]>(result200);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("Server Error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOrgDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMySalesOrg(  cancelToken?: CancelToken | undefined): Promise<SalesOrgDto[]> {
        let url_ = this.baseUrl + "/api/SalesOrg/GetMySalesOrg";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMySalesOrg(_response);
        });
    }

    protected processGetMySalesOrg(response: AxiosResponse): Promise<SalesOrgDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOrgDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOrgDto[]>(result200);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("Server Error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOrgDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSalesOrg(body: SalesOrgDto | undefined , cancelToken?: CancelToken | undefined): Promise<SalesOrgDto> {
        let url_ = this.baseUrl + "/api/SalesOrg/CreateOrUpdateSalesOrg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateSalesOrg(_response);
        });
    }

    protected processCreateOrUpdateSalesOrg(response: AxiosResponse): Promise<SalesOrgDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SalesOrgDto.fromJS(resultData200);
            return Promise.resolve<SalesOrgDto>(result200);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("Server Error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOrgDto>(<any>null);
    }

    /**
     * @param salesOrgId (optional) 
     * @return Success
     */
    deleteSalesOrg(salesOrgId: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SalesOrg/DeleteSalesOrg?";
        if (salesOrgId === null)
            throw new Error("The parameter 'salesOrgId' cannot be null.");
        else if (salesOrgId !== undefined)
            url_ += "salesOrgId=" + encodeURIComponent("" + salesOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSalesOrg(_response);
        });
    }

    protected processDeleteSalesOrg(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("Server Error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class SamlClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    initiateSingleSignOn(returnUrl: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Saml/InitiateSingleSignOn?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitiateSingleSignOn(_response);
        });
    }

    protected processInitiateSingleSignOn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param returnUrl (optional) 
     * @return Success
     */
    callback(returnUrl: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Saml/Callback?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCallback(_response);
        });
    }

    protected processCallback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    connectAs(userId: number | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Saml/ConnectAs?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConnectAs(_response);
        });
    }

    protected processConnectAs(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<string>(result200);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class SnpMappingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(  cancelToken?: CancelToken | undefined): Promise<SnpMapping[]> {
        let url_ = this.baseUrl + "/api/SnpMapping/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SnpMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SnpMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SnpMapping[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SnpMapping[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addSnpMapping(body: SnpMapping | undefined , cancelToken?: CancelToken | undefined): Promise<SnpMapping> {
        let url_ = this.baseUrl + "/api/SnpMapping/AddSnpMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSnpMapping(_response);
        });
    }

    protected processAddSnpMapping(response: AxiosResponse): Promise<SnpMapping> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SnpMapping.fromJS(resultData200);
            return Promise.resolve<SnpMapping>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SnpMapping>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSnpMapping(body: SnpMapping | undefined , cancelToken?: CancelToken | undefined): Promise<SnpMapping> {
        let url_ = this.baseUrl + "/api/SnpMapping/UpdateSnpMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSnpMapping(_response);
        });
    }

    protected processUpdateSnpMapping(response: AxiosResponse): Promise<SnpMapping> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SnpMapping.fromJS(resultData200);
            return Promise.resolve<SnpMapping>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SnpMapping>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCmmfs(body: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/SnpMapping/GetCmmfs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCmmfs(_response);
        });
    }

    protected processGetCmmfs(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class UserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param hint (optional) 
     * @return Success
     */
    getUser(hint: string | undefined , cancelToken?: CancelToken | undefined): Promise<UserPossible[]> {
        let url_ = this.baseUrl + "/api/User/GetUser?";
        if (hint === null)
            throw new Error("The parameter 'hint' cannot be null.");
        else if (hint !== undefined)
            url_ += "hint=" + encodeURIComponent("" + hint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserPossible[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPossible.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserPossible[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPossible[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postUser(body: UserInformations | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/PostUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUser(_response);
        });
    }

    protected processPostUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putUser(body: UserInformations | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/PutUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutUser(_response);
        });
    }

    protected processPutUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deactivateUser(body: UserInformations | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/DeactivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateUser(_response);
        });
    }

    protected processDeactivateUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateUser(body: UserInformations | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/ActivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateUser(_response);
        });
    }

    protected processActivateUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<boolean>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAllUser(  cancelToken?: CancelToken | undefined): Promise<UserInformations[]> {
        let url_ = this.baseUrl + "/api/User/GetAllUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUser(_response);
        });
    }

    protected processGetAllUser(response: AxiosResponse): Promise<UserInformations[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInformations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserInformations[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserInformations> {
        let url_ = this.baseUrl + "/api/User/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<UserInformations> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInformations.fromJS(resultData200);
            return Promise.resolve<UserInformations>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations>(<any>null);
    }

    /**
     * @param salesOrgId (optional) 
     * @return Success
     */
    getAllDemandPlanners(salesOrgId: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserInformations[]> {
        let url_ = this.baseUrl + "/api/User/GetAllDemandPlanners?";
        if (salesOrgId === null)
            throw new Error("The parameter 'salesOrgId' cannot be null.");
        else if (salesOrgId !== undefined)
            url_ += "salesOrgId=" + encodeURIComponent("" + salesOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDemandPlanners(_response);
        });
    }

    protected processGetAllDemandPlanners(response: AxiosResponse): Promise<UserInformations[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInformations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserInformations[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations[]>(<any>null);
    }

    /**
     * @param salesOrgId (optional) 
     * @return Success
     */
    getAllKAMs(salesOrgId: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserInformations[]> {
        let url_ = this.baseUrl + "/api/User/GetAllKAMs?";
        if (salesOrgId === null)
            throw new Error("The parameter 'salesOrgId' cannot be null.");
        else if (salesOrgId !== undefined)
            url_ += "salesOrgId=" + encodeURIComponent("" + salesOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllKAMs(_response);
        });
    }

    protected processGetAllKAMs(response: AxiosResponse): Promise<UserInformations[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInformations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserInformations[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations[]>(<any>null);
    }

    /**
     * @param salesOrgId (optional) 
     * @return Success
     */
    getAllKAMAssistants(salesOrgId: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserInformations[]> {
        let url_ = this.baseUrl + "/api/User/GetAllKAMAssistants?";
        if (salesOrgId === null)
            throw new Error("The parameter 'salesOrgId' cannot be null.");
        else if (salesOrgId !== undefined)
            url_ += "salesOrgId=" + encodeURIComponent("" + salesOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllKAMAssistants(_response);
        });
    }

    protected processGetAllKAMAssistants(response: AxiosResponse): Promise<UserInformations[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInformations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserInformations[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSNPs(  cancelToken?: CancelToken | undefined): Promise<UserInformations[]> {
        let url_ = this.baseUrl + "/api/User/GetAllSNPs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSNPs(_response);
        });
    }

    protected processGetAllSNPs(response: AxiosResponse): Promise<UserInformations[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInformations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserInformations[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations[]>(<any>null);
    }

    /**
     * @return Success
     */
    refreshUser(  cancelToken?: CancelToken | undefined): Promise<UserInformations> {
        let url_ = this.baseUrl + "/api/User/RefreshUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshUser(_response);
        });
    }

    protected processRefreshUser(response: AxiosResponse): Promise<UserInformations> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInformations.fromJS(resultData200);
            return Promise.resolve<UserInformations>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformations>(<any>null);
    }
}

export class UserRoleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllUserRoles(  cancelToken?: CancelToken | undefined): Promise<UserRole[]> {
        let url_ = this.baseUrl + "/api/UserRole/GetAllUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserRoles(_response);
        });
    }

    protected processGetAllUserRoles(response: AxiosResponse): Promise<UserRole[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserRole[]>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRole[]>(<any>null);
    }
}

export class AuthentificationResult implements IAuthentificationResult {
    isAuthenticated?: boolean;
    user?: UserInformations;
    token?: string | undefined;

    constructor(data?: IAuthentificationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.user = _data["user"] ? UserInformations.fromJS(_data["user"]) : <any>undefined;
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthentificationResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthentificationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["token"] = this.token;
        return data; 
    }
}

export interface IAuthentificationResult {
    isAuthenticated?: boolean;
    user?: UserInformations;
    token?: string | undefined;
}

export class CMMF implements ICMMF {
    id?: number;
    salesOrgFileCode?: string | undefined;
    longCommercialCode?: string | undefined;
    shortCommercialCode?: string | undefined;
    productName?: string | undefined;
    code?: string | undefined;
    eanCode?: string | undefined;
    productTypeSeb?: string | undefined;
    brandCode?: number;
    familyCode?: string | undefined;
    subFamilyCode?: string | undefined;
    grossPrice?: number;
    productLine?: string | undefined;
    cmmfGroup?: CMMFGroup;
    isActive?: boolean;
    salesOrgId?: number | undefined;
    salesOrg?: SalesOrg;
    plant?: string | undefined;
    sdStatus?: string | undefined;
    promotionCMMFs?: PromotionCMMF[] | undefined;

    constructor(data?: ICMMF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.salesOrgFileCode = _data["salesOrgFileCode"];
            this.longCommercialCode = _data["longCommercialCode"];
            this.shortCommercialCode = _data["shortCommercialCode"];
            this.productName = _data["productName"];
            this.code = _data["code"];
            this.eanCode = _data["eanCode"];
            this.productTypeSeb = _data["productTypeSeb"];
            this.brandCode = _data["brandCode"];
            this.familyCode = _data["familyCode"];
            this.subFamilyCode = _data["subFamilyCode"];
            this.grossPrice = _data["grossPrice"];
            this.productLine = _data["productLine"];
            this.cmmfGroup = _data["cmmfGroup"];
            this.isActive = _data["isActive"];
            this.salesOrgId = _data["salesOrgId"];
            this.salesOrg = _data["salesOrg"] ? SalesOrg.fromJS(_data["salesOrg"]) : <any>undefined;
            this.plant = _data["plant"];
            this.sdStatus = _data["sdStatus"];
            if (Array.isArray(_data["promotionCMMFs"])) {
                this.promotionCMMFs = [] as any;
                for (let item of _data["promotionCMMFs"])
                    this.promotionCMMFs!.push(PromotionCMMF.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CMMF {
        data = typeof data === 'object' ? data : {};
        let result = new CMMF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salesOrgFileCode"] = this.salesOrgFileCode;
        data["longCommercialCode"] = this.longCommercialCode;
        data["shortCommercialCode"] = this.shortCommercialCode;
        data["productName"] = this.productName;
        data["code"] = this.code;
        data["eanCode"] = this.eanCode;
        data["productTypeSeb"] = this.productTypeSeb;
        data["brandCode"] = this.brandCode;
        data["familyCode"] = this.familyCode;
        data["subFamilyCode"] = this.subFamilyCode;
        data["grossPrice"] = this.grossPrice;
        data["productLine"] = this.productLine;
        data["cmmfGroup"] = this.cmmfGroup;
        data["isActive"] = this.isActive;
        data["salesOrgId"] = this.salesOrgId;
        data["salesOrg"] = this.salesOrg ? this.salesOrg.toJSON() : <any>undefined;
        data["plant"] = this.plant;
        data["sdStatus"] = this.sdStatus;
        if (Array.isArray(this.promotionCMMFs)) {
            data["promotionCMMFs"] = [];
            for (let item of this.promotionCMMFs)
                data["promotionCMMFs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICMMF {
    id?: number;
    salesOrgFileCode?: string | undefined;
    longCommercialCode?: string | undefined;
    shortCommercialCode?: string | undefined;
    productName?: string | undefined;
    code?: string | undefined;
    eanCode?: string | undefined;
    productTypeSeb?: string | undefined;
    brandCode?: number;
    familyCode?: string | undefined;
    subFamilyCode?: string | undefined;
    grossPrice?: number;
    productLine?: string | undefined;
    cmmfGroup?: CMMFGroup;
    isActive?: boolean;
    salesOrgId?: number | undefined;
    salesOrg?: SalesOrg;
    plant?: string | undefined;
    sdStatus?: string | undefined;
    promotionCMMFs?: PromotionCMMF[] | undefined;
}

/** 0 = COOKWARE 1 = ELECTRICAL_COOKING 2 = LINEN_CARE 3 = BEVERAGE 4 = HOME_CLEANING 5 = PERSONAL_CARE 6 = FOOD_PREPARATION 7 = HOME_COMFORT 8 = KITCHENWARE_AND_DINNER 9 = COOKWARE_AND_BAKEWARE 10 = SPARE_PARTS_AND_OTHERS */
export enum CMMFGroup {
    COOKWARE = 0,
    ELECTRICAL_COOKING = 1,
    LINEN_CARE = 2,
    BEVERAGE = 3,
    HOME_CLEANING = 4,
    PERSONAL_CARE = 5,
    FOOD_PREPARATION = 6,
    HOME_COMFORT = 7,
    KITCHENWARE_AND_DINNER = 8,
    COOKWARE_AND_BAKEWARE = 9,
    SPARE_PARTS_AND_OTHERS = 10,
}

export class CancelReason implements ICancelReason {
    id?: number;
    value?: string | undefined;
    label?: string | undefined;
    salesOrgId?: number;
    salesOrg?: SalesOrg;

    constructor(data?: ICancelReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.label = _data["label"];
            this.salesOrgId = _data["salesOrgId"];
            this.salesOrg = _data["salesOrg"] ? SalesOrg.fromJS(_data["salesOrg"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelReason {
        data = typeof data === 'object' ? data : {};
        let result = new CancelReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label;
        data["salesOrgId"] = this.salesOrgId;
        data["salesOrg"] = this.salesOrg ? this.salesOrg.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICancelReason {
    id?: number;
    value?: string | undefined;
    label?: string | undefined;
    salesOrgId?: number;
    salesOrg?: SalesOrg;
}

export class Customer implements ICustomer {
    id?: number;
    salesOrgFileCode?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    distributionChannelCode?: string | undefined;
    bannerCode?: string | undefined;
    mla?: string | undefined;
    forcedDocType?: string | undefined;
    isActive?: boolean;
    salesOrgId?: number | undefined;
    salesOrg?: SalesOrg;
    promotions?: Promotion[] | undefined;
    group?: ECustomerGroup;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.salesOrgFileCode = _data["salesOrgFileCode"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.distributionChannelCode = _data["distributionChannelCode"];
            this.bannerCode = _data["bannerCode"];
            this.mla = _data["mla"];
            this.forcedDocType = _data["forcedDocType"];
            this.isActive = _data["isActive"];
            this.salesOrgId = _data["salesOrgId"];
            this.salesOrg = _data["salesOrg"] ? SalesOrg.fromJS(_data["salesOrg"]) : <any>undefined;
            if (Array.isArray(_data["promotions"])) {
                this.promotions = [] as any;
                for (let item of _data["promotions"])
                    this.promotions!.push(Promotion.fromJS(item));
            }
            this.group = _data["group"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salesOrgFileCode"] = this.salesOrgFileCode;
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type;
        data["distributionChannelCode"] = this.distributionChannelCode;
        data["bannerCode"] = this.bannerCode;
        data["mla"] = this.mla;
        data["forcedDocType"] = this.forcedDocType;
        data["isActive"] = this.isActive;
        data["salesOrgId"] = this.salesOrgId;
        data["salesOrg"] = this.salesOrg ? this.salesOrg.toJSON() : <any>undefined;
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        data["group"] = this.group;
        return data; 
    }
}

export interface ICustomer {
    id?: number;
    salesOrgFileCode?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    distributionChannelCode?: string | undefined;
    bannerCode?: string | undefined;
    mla?: string | undefined;
    forcedDocType?: string | undefined;
    isActive?: boolean;
    salesOrgId?: number | undefined;
    salesOrg?: SalesOrg;
    promotions?: Promotion[] | undefined;
    group?: ECustomerGroup;
}

export class CustomerDto implements ICustomerDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    distributionChannelCode?: string | undefined;
    bannerCode?: string | undefined;
    mla?: string | undefined;
    isActive?: boolean;
    group?: ECustomerGroup;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.distributionChannelCode = _data["distributionChannelCode"];
            this.bannerCode = _data["bannerCode"];
            this.mla = _data["mla"];
            this.isActive = _data["isActive"];
            this.group = _data["group"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type;
        data["distributionChannelCode"] = this.distributionChannelCode;
        data["bannerCode"] = this.bannerCode;
        data["mla"] = this.mla;
        data["isActive"] = this.isActive;
        data["group"] = this.group;
        return data; 
    }
}

export interface ICustomerDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    distributionChannelCode?: string | undefined;
    bannerCode?: string | undefined;
    mla?: string | undefined;
    isActive?: boolean;
    group?: ECustomerGroup;
}

export class Delegation implements IDelegation {
    id?: number;
    delegatorUserId?: number;
    delegator?: UserInformations;
    surrogateUserId?: number;
    surrogate?: UserInformations;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IDelegation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegatorUserId = _data["delegatorUserId"];
            this.delegator = _data["delegator"] ? UserInformations.fromJS(_data["delegator"]) : <any>undefined;
            this.surrogateUserId = _data["surrogateUserId"];
            this.surrogate = _data["surrogate"] ? UserInformations.fromJS(_data["surrogate"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Delegation {
        data = typeof data === 'object' ? data : {};
        let result = new Delegation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegatorUserId"] = this.delegatorUserId;
        data["delegator"] = this.delegator ? this.delegator.toJSON() : <any>undefined;
        data["surrogateUserId"] = this.surrogateUserId;
        data["surrogate"] = this.surrogate ? this.surrogate.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDelegation {
    id?: number;
    delegatorUserId?: number;
    delegator?: UserInformations;
    surrogateUserId?: number;
    surrogate?: UserInformations;
    startDate?: Date;
    endDate?: Date;
}

export class DelegationsUpdate implements IDelegationsUpdate {
    userId?: number;
    delegations?: Delegation[] | undefined;

    constructor(data?: IDelegationsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["delegations"])) {
                this.delegations = [] as any;
                for (let item of _data["delegations"])
                    this.delegations!.push(Delegation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DelegationsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.delegations)) {
            data["delegations"] = [];
            for (let item of this.delegations)
                data["delegations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDelegationsUpdate {
    userId?: number;
    delegations?: Delegation[] | undefined;
}

/** 0 = APO 1 = O9 2 = APO_AND_O9 */
export enum ExportType {
    APO = 0,
    O9 = 1,
    APO_AND_O9 = 2,
}

export class LoginParameter implements ILoginParameter {
    tokenAd?: string | undefined;
    id?: string | undefined;
    secretAdminPassword?: string | undefined;

    constructor(data?: ILoginParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenAd = _data["tokenAd"];
            this.id = _data["id"];
            this.secretAdminPassword = _data["secretAdminPassword"];
        }
    }

    static fromJS(data: any): LoginParameter {
        data = typeof data === 'object' ? data : {};
        let result = new LoginParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenAd"] = this.tokenAd;
        data["id"] = this.id;
        data["secretAdminPassword"] = this.secretAdminPassword;
        return data; 
    }
}

export interface ILoginParameter {
    tokenAd?: string | undefined;
    id?: string | undefined;
    secretAdminPassword?: string | undefined;
}

export class Promotion implements IPromotion {
    id?: number;
    promotionName!: string;
    type?: EPromotionType;
    mechanism?: string | undefined;
    kamComment?: string | undefined;
    dpComment?: string | undefined;
    shopsNumber?: number;
    statusId?: number;
    status?: PromotionStatus;
    isQuotationEnabled?: boolean;
    quotationNumber?: string | undefined;
    customerId?: number | undefined;
    customer?: Customer;
    createUserId?: number | undefined;
    createUser?: UserInformations;
    creationDate?: Date;
    modificationDate?: Date;
    sellInStart?: Date | undefined;
    sellInEnd?: Date | undefined;
    sellOutStart?: Date | undefined;
    sellOutEnd?: Date | undefined;
    supplyDeadline?: Date | undefined;
    kamId?: number | undefined;
    kam?: UserInformations;
    assistantKAMListId?: number[] | undefined;
    readonly assistantKAM?: UserInformations[] | undefined;
    isOnlineShop?: boolean;
    isFixedSlot?: boolean;
    plannedDeliveryDate?: Date;
    criticity?: number | undefined;
    lock?: PromotionLock;
    demandPlannerListId?: number[] | undefined;
    readonly demandPlannerList?: UserInformations[] | undefined;
    promotionDemandPlanners?: PromotionDemandPlanner[] | undefined;
    promotionKamAssistants?: PromotionKamAssistant[] | undefined;
    salesOrgId?: number | undefined;
    salesOrg?: SalesOrg;
    promotionCMMFs?: PromotionCMMF[] | undefined;
    history?: PromotionHistory[] | undefined;

    constructor(data?: IPromotion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.promotionName = _data["promotionName"];
            this.type = _data["type"];
            this.mechanism = _data["mechanism"];
            this.kamComment = _data["kamComment"];
            this.dpComment = _data["dpComment"];
            this.shopsNumber = _data["shopsNumber"];
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? PromotionStatus.fromJS(_data["status"]) : <any>undefined;
            this.isQuotationEnabled = _data["isQuotationEnabled"];
            this.quotationNumber = _data["quotationNumber"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.createUser = _data["createUser"] ? UserInformations.fromJS(_data["createUser"]) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>undefined;
            this.sellInStart = _data["sellInStart"] ? new Date(_data["sellInStart"].toString()) : <any>undefined;
            this.sellInEnd = _data["sellInEnd"] ? new Date(_data["sellInEnd"].toString()) : <any>undefined;
            this.sellOutStart = _data["sellOutStart"] ? new Date(_data["sellOutStart"].toString()) : <any>undefined;
            this.sellOutEnd = _data["sellOutEnd"] ? new Date(_data["sellOutEnd"].toString()) : <any>undefined;
            this.supplyDeadline = _data["supplyDeadline"] ? new Date(_data["supplyDeadline"].toString()) : <any>undefined;
            this.kamId = _data["kamId"];
            this.kam = _data["kam"] ? UserInformations.fromJS(_data["kam"]) : <any>undefined;
            if (Array.isArray(_data["assistantKAMListId"])) {
                this.assistantKAMListId = [] as any;
                for (let item of _data["assistantKAMListId"])
                    this.assistantKAMListId!.push(item);
            }
            if (Array.isArray(_data["assistantKAM"])) {
                (<any>this).assistantKAM = [] as any;
                for (let item of _data["assistantKAM"])
                    (<any>this).assistantKAM!.push(UserInformations.fromJS(item));
            }
            this.isOnlineShop = _data["isOnlineShop"];
            this.isFixedSlot = _data["isFixedSlot"];
            this.plannedDeliveryDate = _data["plannedDeliveryDate"] ? new Date(_data["plannedDeliveryDate"].toString()) : <any>undefined;
            this.criticity = _data["criticity"];
            this.lock = _data["lock"] ? PromotionLock.fromJS(_data["lock"]) : <any>undefined;
            if (Array.isArray(_data["demandPlannerListId"])) {
                this.demandPlannerListId = [] as any;
                for (let item of _data["demandPlannerListId"])
                    this.demandPlannerListId!.push(item);
            }
            if (Array.isArray(_data["demandPlannerList"])) {
                (<any>this).demandPlannerList = [] as any;
                for (let item of _data["demandPlannerList"])
                    (<any>this).demandPlannerList!.push(UserInformations.fromJS(item));
            }
            if (Array.isArray(_data["promotionDemandPlanners"])) {
                this.promotionDemandPlanners = [] as any;
                for (let item of _data["promotionDemandPlanners"])
                    this.promotionDemandPlanners!.push(PromotionDemandPlanner.fromJS(item));
            }
            if (Array.isArray(_data["promotionKamAssistants"])) {
                this.promotionKamAssistants = [] as any;
                for (let item of _data["promotionKamAssistants"])
                    this.promotionKamAssistants!.push(PromotionKamAssistant.fromJS(item));
            }
            this.salesOrgId = _data["salesOrgId"];
            this.salesOrg = _data["salesOrg"] ? SalesOrg.fromJS(_data["salesOrg"]) : <any>undefined;
            if (Array.isArray(_data["promotionCMMFs"])) {
                this.promotionCMMFs = [] as any;
                for (let item of _data["promotionCMMFs"])
                    this.promotionCMMFs!.push(PromotionCMMF.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PromotionHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Promotion {
        data = typeof data === 'object' ? data : {};
        let result = new Promotion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["promotionName"] = this.promotionName;
        data["type"] = this.type;
        data["mechanism"] = this.mechanism;
        data["kamComment"] = this.kamComment;
        data["dpComment"] = this.dpComment;
        data["shopsNumber"] = this.shopsNumber;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["isQuotationEnabled"] = this.isQuotationEnabled;
        data["quotationNumber"] = this.quotationNumber;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["createUser"] = this.createUser ? this.createUser.toJSON() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        data["sellInStart"] = this.sellInStart ? this.sellInStart.toISOString() : <any>undefined;
        data["sellInEnd"] = this.sellInEnd ? this.sellInEnd.toISOString() : <any>undefined;
        data["sellOutStart"] = this.sellOutStart ? this.sellOutStart.toISOString() : <any>undefined;
        data["sellOutEnd"] = this.sellOutEnd ? this.sellOutEnd.toISOString() : <any>undefined;
        data["supplyDeadline"] = this.supplyDeadline ? this.supplyDeadline.toISOString() : <any>undefined;
        data["kamId"] = this.kamId;
        data["kam"] = this.kam ? this.kam.toJSON() : <any>undefined;
        if (Array.isArray(this.assistantKAMListId)) {
            data["assistantKAMListId"] = [];
            for (let item of this.assistantKAMListId)
                data["assistantKAMListId"].push(item);
        }
        if (Array.isArray(this.assistantKAM)) {
            data["assistantKAM"] = [];
            for (let item of this.assistantKAM)
                data["assistantKAM"].push(item.toJSON());
        }
        data["isOnlineShop"] = this.isOnlineShop;
        data["isFixedSlot"] = this.isFixedSlot;
        data["plannedDeliveryDate"] = this.plannedDeliveryDate ? this.plannedDeliveryDate.toISOString() : <any>undefined;
        data["criticity"] = this.criticity;
        data["lock"] = this.lock ? this.lock.toJSON() : <any>undefined;
        if (Array.isArray(this.demandPlannerListId)) {
            data["demandPlannerListId"] = [];
            for (let item of this.demandPlannerListId)
                data["demandPlannerListId"].push(item);
        }
        if (Array.isArray(this.demandPlannerList)) {
            data["demandPlannerList"] = [];
            for (let item of this.demandPlannerList)
                data["demandPlannerList"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionDemandPlanners)) {
            data["promotionDemandPlanners"] = [];
            for (let item of this.promotionDemandPlanners)
                data["promotionDemandPlanners"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionKamAssistants)) {
            data["promotionKamAssistants"] = [];
            for (let item of this.promotionKamAssistants)
                data["promotionKamAssistants"].push(item.toJSON());
        }
        data["salesOrgId"] = this.salesOrgId;
        data["salesOrg"] = this.salesOrg ? this.salesOrg.toJSON() : <any>undefined;
        if (Array.isArray(this.promotionCMMFs)) {
            data["promotionCMMFs"] = [];
            for (let item of this.promotionCMMFs)
                data["promotionCMMFs"].push(item.toJSON());
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotion {
    id?: number;
    promotionName: string;
    type?: EPromotionType;
    mechanism?: string | undefined;
    kamComment?: string | undefined;
    dpComment?: string | undefined;
    shopsNumber?: number;
    statusId?: number;
    status?: PromotionStatus;
    isQuotationEnabled?: boolean;
    quotationNumber?: string | undefined;
    customerId?: number | undefined;
    customer?: Customer;
    createUserId?: number | undefined;
    createUser?: UserInformations;
    creationDate?: Date;
    modificationDate?: Date;
    sellInStart?: Date | undefined;
    sellInEnd?: Date | undefined;
    sellOutStart?: Date | undefined;
    sellOutEnd?: Date | undefined;
    supplyDeadline?: Date | undefined;
    kamId?: number | undefined;
    kam?: UserInformations;
    assistantKAMListId?: number[] | undefined;
    assistantKAM?: UserInformations[] | undefined;
    isOnlineShop?: boolean;
    isFixedSlot?: boolean;
    plannedDeliveryDate?: Date;
    criticity?: number | undefined;
    lock?: PromotionLock;
    demandPlannerListId?: number[] | undefined;
    demandPlannerList?: UserInformations[] | undefined;
    promotionDemandPlanners?: PromotionDemandPlanner[] | undefined;
    promotionKamAssistants?: PromotionKamAssistant[] | undefined;
    salesOrgId?: number | undefined;
    salesOrg?: SalesOrg;
    promotionCMMFs?: PromotionCMMF[] | undefined;
    history?: PromotionHistory[] | undefined;
}

export class PromotionCMMF implements IPromotionCMMF {
    id?: number;
    cmmfId?: number;
    quantity?: number;
    kamComment?: string | undefined;
    dpComment?: string | undefined;
    snpComment?: string | undefined;
    acceptSupply?: boolean;
    flagSupply?: boolean;
    buStatus?: EBUStatus;
    supplyDeadline?: Date | undefined;
    promotionId?: number;
    sapNumber?: number;
    cmmf?: CMMF;

    constructor(data?: IPromotionCMMF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cmmfId = _data["cmmfId"];
            this.quantity = _data["quantity"];
            this.kamComment = _data["kamComment"];
            this.dpComment = _data["dpComment"];
            this.snpComment = _data["snpComment"];
            this.acceptSupply = _data["acceptSupply"];
            this.flagSupply = _data["flagSupply"];
            this.buStatus = _data["buStatus"];
            this.supplyDeadline = _data["supplyDeadline"] ? new Date(_data["supplyDeadline"].toString()) : <any>undefined;
            this.promotionId = _data["promotionId"];
            this.sapNumber = _data["sapNumber"];
            this.cmmf = _data["cmmf"] ? CMMF.fromJS(_data["cmmf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionCMMF {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionCMMF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cmmfId"] = this.cmmfId;
        data["quantity"] = this.quantity;
        data["kamComment"] = this.kamComment;
        data["dpComment"] = this.dpComment;
        data["snpComment"] = this.snpComment;
        data["acceptSupply"] = this.acceptSupply;
        data["flagSupply"] = this.flagSupply;
        data["buStatus"] = this.buStatus;
        data["supplyDeadline"] = this.supplyDeadline ? this.supplyDeadline.toISOString() : <any>undefined;
        data["promotionId"] = this.promotionId;
        data["sapNumber"] = this.sapNumber;
        data["cmmf"] = this.cmmf ? this.cmmf.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPromotionCMMF {
    id?: number;
    cmmfId?: number;
    quantity?: number;
    kamComment?: string | undefined;
    dpComment?: string | undefined;
    snpComment?: string | undefined;
    acceptSupply?: boolean;
    flagSupply?: boolean;
    buStatus?: EBUStatus;
    supplyDeadline?: Date | undefined;
    promotionId?: number;
    sapNumber?: number;
    cmmf?: CMMF;
}

export class PromotionDemandPlanner implements IPromotionDemandPlanner {
    promotionId?: number;
    promotion?: Promotion;
    demandPlannerId?: number;
    demandPlanner?: UserInformations;

    constructor(data?: IPromotionDemandPlanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? Promotion.fromJS(_data["promotion"]) : <any>undefined;
            this.demandPlannerId = _data["demandPlannerId"];
            this.demandPlanner = _data["demandPlanner"] ? UserInformations.fromJS(_data["demandPlanner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionDemandPlanner {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionDemandPlanner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["demandPlannerId"] = this.demandPlannerId;
        data["demandPlanner"] = this.demandPlanner ? this.demandPlanner.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPromotionDemandPlanner {
    promotionId?: number;
    promotion?: Promotion;
    demandPlannerId?: number;
    demandPlanner?: UserInformations;
}

export class PromotionHistory implements IPromotionHistory {
    id?: number;
    revision?: number;
    modificationDate?: Date;
    oldValues?: string | undefined;
    newValues?: string | undefined;
    userId?: number;
    user?: UserInformations;
    modelId?: number;
    model?: Promotion;

    constructor(data?: IPromotionHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.revision = _data["revision"];
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>undefined;
            this.oldValues = _data["oldValues"];
            this.newValues = _data["newValues"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserInformations.fromJS(_data["user"]) : <any>undefined;
            this.modelId = _data["modelId"];
            this.model = _data["model"] ? Promotion.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["revision"] = this.revision;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        data["oldValues"] = this.oldValues;
        data["newValues"] = this.newValues;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["modelId"] = this.modelId;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPromotionHistory {
    id?: number;
    revision?: number;
    modificationDate?: Date;
    oldValues?: string | undefined;
    newValues?: string | undefined;
    userId?: number;
    user?: UserInformations;
    modelId?: number;
    model?: Promotion;
}

export class PromotionInput implements IPromotionInput {
    id?: number;
    creationDate?: Date;
    modificationDate?: Date;
    promotionName!: string;
    statusId?: EPromotionStatus;
    statusName?: string | undefined;
    isQuotationEnabled?: boolean;
    quotationNumber?: string | undefined;
    criticity?: number | undefined;
    customerId!: number;
    sellInStart?: Date | undefined;
    sellInEnd?: Date | undefined;
    sellOutStart?: Date | undefined;
    sellOutEnd?: Date | undefined;
    supplyDeadline?: Date | undefined;
    readonly eta?: string | undefined;
    type?: EPromotionType;
    mechanism?: string | undefined;
    kamComment?: string | undefined;
    dpComment?: string | undefined;
    shopsNumber?: number | undefined;
    isOnlineShop?: boolean;
    isFixedSlot?: boolean;
    kamId?: number | undefined;
    assistantKAMListId?: number[] | undefined;
    editedByDP?: number | undefined;
    demandPlannerListId?: number[] | undefined;
    salesOrgId!: number;
    listOfSelectedCMMF?: SelectedCMMF[] | undefined;
    plannedDeliveryDate?: Date;
    history?: PromotionHistory[] | undefined;

    constructor(data?: IPromotionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>undefined;
            this.promotionName = _data["promotionName"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.isQuotationEnabled = _data["isQuotationEnabled"];
            this.quotationNumber = _data["quotationNumber"];
            this.criticity = _data["criticity"];
            this.customerId = _data["customerId"];
            this.sellInStart = _data["sellInStart"] ? new Date(_data["sellInStart"].toString()) : <any>undefined;
            this.sellInEnd = _data["sellInEnd"] ? new Date(_data["sellInEnd"].toString()) : <any>undefined;
            this.sellOutStart = _data["sellOutStart"] ? new Date(_data["sellOutStart"].toString()) : <any>undefined;
            this.sellOutEnd = _data["sellOutEnd"] ? new Date(_data["sellOutEnd"].toString()) : <any>undefined;
            this.supplyDeadline = _data["supplyDeadline"] ? new Date(_data["supplyDeadline"].toString()) : <any>undefined;
            (<any>this).eta = _data["eta"];
            this.type = _data["type"];
            this.mechanism = _data["mechanism"];
            this.kamComment = _data["kamComment"];
            this.dpComment = _data["dpComment"];
            this.shopsNumber = _data["shopsNumber"];
            this.isOnlineShop = _data["isOnlineShop"];
            this.isFixedSlot = _data["isFixedSlot"];
            this.kamId = _data["kamId"];
            if (Array.isArray(_data["assistantKAMListId"])) {
                this.assistantKAMListId = [] as any;
                for (let item of _data["assistantKAMListId"])
                    this.assistantKAMListId!.push(item);
            }
            this.editedByDP = _data["editedByDP"];
            if (Array.isArray(_data["demandPlannerListId"])) {
                this.demandPlannerListId = [] as any;
                for (let item of _data["demandPlannerListId"])
                    this.demandPlannerListId!.push(item);
            }
            this.salesOrgId = _data["salesOrgId"];
            if (Array.isArray(_data["listOfSelectedCMMF"])) {
                this.listOfSelectedCMMF = [] as any;
                for (let item of _data["listOfSelectedCMMF"])
                    this.listOfSelectedCMMF!.push(SelectedCMMF.fromJS(item));
            }
            this.plannedDeliveryDate = _data["plannedDeliveryDate"] ? new Date(_data["plannedDeliveryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PromotionHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionInput {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        data["promotionName"] = this.promotionName;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["isQuotationEnabled"] = this.isQuotationEnabled;
        data["quotationNumber"] = this.quotationNumber;
        data["criticity"] = this.criticity;
        data["customerId"] = this.customerId;
        data["sellInStart"] = this.sellInStart ? this.sellInStart.toISOString() : <any>undefined;
        data["sellInEnd"] = this.sellInEnd ? this.sellInEnd.toISOString() : <any>undefined;
        data["sellOutStart"] = this.sellOutStart ? this.sellOutStart.toISOString() : <any>undefined;
        data["sellOutEnd"] = this.sellOutEnd ? this.sellOutEnd.toISOString() : <any>undefined;
        data["supplyDeadline"] = this.supplyDeadline ? this.supplyDeadline.toISOString() : <any>undefined;
        data["eta"] = this.eta;
        data["type"] = this.type;
        data["mechanism"] = this.mechanism;
        data["kamComment"] = this.kamComment;
        data["dpComment"] = this.dpComment;
        data["shopsNumber"] = this.shopsNumber;
        data["isOnlineShop"] = this.isOnlineShop;
        data["isFixedSlot"] = this.isFixedSlot;
        data["kamId"] = this.kamId;
        if (Array.isArray(this.assistantKAMListId)) {
            data["assistantKAMListId"] = [];
            for (let item of this.assistantKAMListId)
                data["assistantKAMListId"].push(item);
        }
        data["editedByDP"] = this.editedByDP;
        if (Array.isArray(this.demandPlannerListId)) {
            data["demandPlannerListId"] = [];
            for (let item of this.demandPlannerListId)
                data["demandPlannerListId"].push(item);
        }
        data["salesOrgId"] = this.salesOrgId;
        if (Array.isArray(this.listOfSelectedCMMF)) {
            data["listOfSelectedCMMF"] = [];
            for (let item of this.listOfSelectedCMMF)
                data["listOfSelectedCMMF"].push(item.toJSON());
        }
        data["plannedDeliveryDate"] = this.plannedDeliveryDate ? this.plannedDeliveryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionInput {
    id?: number;
    creationDate?: Date;
    modificationDate?: Date;
    promotionName: string;
    statusId?: EPromotionStatus;
    statusName?: string | undefined;
    isQuotationEnabled?: boolean;
    quotationNumber?: string | undefined;
    criticity?: number | undefined;
    customerId: number;
    sellInStart?: Date | undefined;
    sellInEnd?: Date | undefined;
    sellOutStart?: Date | undefined;
    sellOutEnd?: Date | undefined;
    supplyDeadline?: Date | undefined;
    eta?: string | undefined;
    type?: EPromotionType;
    mechanism?: string | undefined;
    kamComment?: string | undefined;
    dpComment?: string | undefined;
    shopsNumber?: number | undefined;
    isOnlineShop?: boolean;
    isFixedSlot?: boolean;
    kamId?: number | undefined;
    assistantKAMListId?: number[] | undefined;
    editedByDP?: number | undefined;
    demandPlannerListId?: number[] | undefined;
    salesOrgId: number;
    listOfSelectedCMMF?: SelectedCMMF[] | undefined;
    plannedDeliveryDate?: Date;
    history?: PromotionHistory[] | undefined;
}

export class PromotionKamAssistant implements IPromotionKamAssistant {
    promotionId?: number;
    promotion?: Promotion;
    kamAssistantId?: number;
    kamAssistant?: UserInformations;

    constructor(data?: IPromotionKamAssistant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? Promotion.fromJS(_data["promotion"]) : <any>undefined;
            this.kamAssistantId = _data["kamAssistantId"];
            this.kamAssistant = _data["kamAssistant"] ? UserInformations.fromJS(_data["kamAssistant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionKamAssistant {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionKamAssistant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["kamAssistantId"] = this.kamAssistantId;
        data["kamAssistant"] = this.kamAssistant ? this.kamAssistant.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPromotionKamAssistant {
    promotionId?: number;
    promotion?: Promotion;
    kamAssistantId?: number;
    kamAssistant?: UserInformations;
}

export class PromotionListFilter implements IPromotionListFilter {
    listOption?: EPromotionListOption;
    selectedSalesOrgs?: number[] | undefined;
    selectedStatus?: number[] | undefined;
    searchText?: string | undefined;
    sellInStart?: Date | undefined;
    sellInEnd?: Date | undefined;
    sellOutStart?: Date | undefined;
    sellOutEnd?: Date | undefined;
    selectedProductLine?: number[] | undefined;
    selectedCustomer?: number[] | undefined;

    constructor(data?: IPromotionListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listOption = _data["listOption"];
            if (Array.isArray(_data["selectedSalesOrgs"])) {
                this.selectedSalesOrgs = [] as any;
                for (let item of _data["selectedSalesOrgs"])
                    this.selectedSalesOrgs!.push(item);
            }
            if (Array.isArray(_data["selectedStatus"])) {
                this.selectedStatus = [] as any;
                for (let item of _data["selectedStatus"])
                    this.selectedStatus!.push(item);
            }
            this.searchText = _data["searchText"];
            this.sellInStart = _data["sellInStart"] ? new Date(_data["sellInStart"].toString()) : <any>undefined;
            this.sellInEnd = _data["sellInEnd"] ? new Date(_data["sellInEnd"].toString()) : <any>undefined;
            this.sellOutStart = _data["sellOutStart"] ? new Date(_data["sellOutStart"].toString()) : <any>undefined;
            this.sellOutEnd = _data["sellOutEnd"] ? new Date(_data["sellOutEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["selectedProductLine"])) {
                this.selectedProductLine = [] as any;
                for (let item of _data["selectedProductLine"])
                    this.selectedProductLine!.push(item);
            }
            if (Array.isArray(_data["selectedCustomer"])) {
                this.selectedCustomer = [] as any;
                for (let item of _data["selectedCustomer"])
                    this.selectedCustomer!.push(item);
            }
        }
    }

    static fromJS(data: any): PromotionListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listOption"] = this.listOption;
        if (Array.isArray(this.selectedSalesOrgs)) {
            data["selectedSalesOrgs"] = [];
            for (let item of this.selectedSalesOrgs)
                data["selectedSalesOrgs"].push(item);
        }
        if (Array.isArray(this.selectedStatus)) {
            data["selectedStatus"] = [];
            for (let item of this.selectedStatus)
                data["selectedStatus"].push(item);
        }
        data["searchText"] = this.searchText;
        data["sellInStart"] = this.sellInStart ? this.sellInStart.toISOString() : <any>undefined;
        data["sellInEnd"] = this.sellInEnd ? this.sellInEnd.toISOString() : <any>undefined;
        data["sellOutStart"] = this.sellOutStart ? this.sellOutStart.toISOString() : <any>undefined;
        data["sellOutEnd"] = this.sellOutEnd ? this.sellOutEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.selectedProductLine)) {
            data["selectedProductLine"] = [];
            for (let item of this.selectedProductLine)
                data["selectedProductLine"].push(item);
        }
        if (Array.isArray(this.selectedCustomer)) {
            data["selectedCustomer"] = [];
            for (let item of this.selectedCustomer)
                data["selectedCustomer"].push(item);
        }
        return data; 
    }
}

export interface IPromotionListFilter {
    listOption?: EPromotionListOption;
    selectedSalesOrgs?: number[] | undefined;
    selectedStatus?: number[] | undefined;
    searchText?: string | undefined;
    sellInStart?: Date | undefined;
    sellInEnd?: Date | undefined;
    sellOutStart?: Date | undefined;
    sellOutEnd?: Date | undefined;
    selectedProductLine?: number[] | undefined;
    selectedCustomer?: number[] | undefined;
}

export class PromotionLock implements IPromotionLock {
    id?: number;
    promotionId?: number;
    promotion?: Promotion;
    lockUserId?: number | undefined;
    lockUser?: UserInformations;
    lockedDate?: Date;

    constructor(data?: IPromotionLock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? Promotion.fromJS(_data["promotion"]) : <any>undefined;
            this.lockUserId = _data["lockUserId"];
            this.lockUser = _data["lockUser"] ? UserInformations.fromJS(_data["lockUser"]) : <any>undefined;
            this.lockedDate = _data["lockedDate"] ? new Date(_data["lockedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionLock {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionLock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["lockUserId"] = this.lockUserId;
        data["lockUser"] = this.lockUser ? this.lockUser.toJSON() : <any>undefined;
        data["lockedDate"] = this.lockedDate ? this.lockedDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPromotionLock {
    id?: number;
    promotionId?: number;
    promotion?: Promotion;
    lockUserId?: number | undefined;
    lockUser?: UserInformations;
    lockedDate?: Date;
}

export class PromotionStatus implements IPromotionStatus {
    id?: number;
    name!: string;
    promotions?: Promotion[] | undefined;

    constructor(data?: IPromotionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["promotions"])) {
                this.promotions = [] as any;
                for (let item of _data["promotions"])
                    this.promotions!.push(Promotion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionStatus {
    id?: number;
    name: string;
    promotions?: Promotion[] | undefined;
}

export class PromotionStatusDto implements IPromotionStatusDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPromotionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PromotionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IPromotionStatusDto {
    id?: number;
    name?: string | undefined;
}

export class SalesOrg implements ISalesOrg {
    id?: number;
    fileCode!: string;
    compagnyCode!: string;
    sapCode!: string;
    description!: string;
    docType?: string | undefined;
    deliveryBlock?: string | undefined;
    orderReason?: string | undefined;
    isMatureForSAP?: boolean;
    fixQuotationType?: string | undefined;
    lvlCustomer?: ECustomerGroup;
    isDisabled?: boolean;
    offsetAPO?: number;
    exportType?: ExportType;
    cmmFs?: CMMF[] | undefined;
    customers?: Customer[] | undefined;
    promotions?: Promotion[] | undefined;
    userSalesOrg?: UserSalesOrg[] | undefined;
    cancelReasons?: CancelReason[] | undefined;
    salesOrgImports?: SalesOrgImport[] | undefined;

    constructor(data?: ISalesOrg) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileCode = _data["fileCode"];
            this.compagnyCode = _data["compagnyCode"];
            this.sapCode = _data["sapCode"];
            this.description = _data["description"];
            this.docType = _data["docType"];
            this.deliveryBlock = _data["deliveryBlock"];
            this.orderReason = _data["orderReason"];
            this.isMatureForSAP = _data["isMatureForSAP"];
            this.fixQuotationType = _data["fixQuotationType"];
            this.lvlCustomer = _data["lvlCustomer"];
            this.isDisabled = _data["isDisabled"];
            this.offsetAPO = _data["offsetAPO"];
            this.exportType = _data["exportType"];
            if (Array.isArray(_data["cmmFs"])) {
                this.cmmFs = [] as any;
                for (let item of _data["cmmFs"])
                    this.cmmFs!.push(CMMF.fromJS(item));
            }
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(Customer.fromJS(item));
            }
            if (Array.isArray(_data["promotions"])) {
                this.promotions = [] as any;
                for (let item of _data["promotions"])
                    this.promotions!.push(Promotion.fromJS(item));
            }
            if (Array.isArray(_data["userSalesOrg"])) {
                this.userSalesOrg = [] as any;
                for (let item of _data["userSalesOrg"])
                    this.userSalesOrg!.push(UserSalesOrg.fromJS(item));
            }
            if (Array.isArray(_data["cancelReasons"])) {
                this.cancelReasons = [] as any;
                for (let item of _data["cancelReasons"])
                    this.cancelReasons!.push(CancelReason.fromJS(item));
            }
            if (Array.isArray(_data["salesOrgImports"])) {
                this.salesOrgImports = [] as any;
                for (let item of _data["salesOrgImports"])
                    this.salesOrgImports!.push(SalesOrgImport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesOrg {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileCode"] = this.fileCode;
        data["compagnyCode"] = this.compagnyCode;
        data["sapCode"] = this.sapCode;
        data["description"] = this.description;
        data["docType"] = this.docType;
        data["deliveryBlock"] = this.deliveryBlock;
        data["orderReason"] = this.orderReason;
        data["isMatureForSAP"] = this.isMatureForSAP;
        data["fixQuotationType"] = this.fixQuotationType;
        data["lvlCustomer"] = this.lvlCustomer;
        data["isDisabled"] = this.isDisabled;
        data["offsetAPO"] = this.offsetAPO;
        data["exportType"] = this.exportType;
        if (Array.isArray(this.cmmFs)) {
            data["cmmFs"] = [];
            for (let item of this.cmmFs)
                data["cmmFs"].push(item.toJSON());
        }
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        if (Array.isArray(this.userSalesOrg)) {
            data["userSalesOrg"] = [];
            for (let item of this.userSalesOrg)
                data["userSalesOrg"].push(item.toJSON());
        }
        if (Array.isArray(this.cancelReasons)) {
            data["cancelReasons"] = [];
            for (let item of this.cancelReasons)
                data["cancelReasons"].push(item.toJSON());
        }
        if (Array.isArray(this.salesOrgImports)) {
            data["salesOrgImports"] = [];
            for (let item of this.salesOrgImports)
                data["salesOrgImports"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesOrg {
    id?: number;
    fileCode: string;
    compagnyCode: string;
    sapCode: string;
    description: string;
    docType?: string | undefined;
    deliveryBlock?: string | undefined;
    orderReason?: string | undefined;
    isMatureForSAP?: boolean;
    fixQuotationType?: string | undefined;
    lvlCustomer?: ECustomerGroup;
    isDisabled?: boolean;
    offsetAPO?: number;
    exportType?: ExportType;
    cmmFs?: CMMF[] | undefined;
    customers?: Customer[] | undefined;
    promotions?: Promotion[] | undefined;
    userSalesOrg?: UserSalesOrg[] | undefined;
    cancelReasons?: CancelReason[] | undefined;
    salesOrgImports?: SalesOrgImport[] | undefined;
}

export class SalesOrgDto implements ISalesOrgDto {
    id!: number;
    fileCode!: string;
    compagnyCode!: string;
    sapCode!: string;
    description!: string;
    docType?: string | undefined;
    deliveryBlock!: string;
    orderReason!: string;
    isMatureForSAP!: boolean;
    fixQuotationType?: string | undefined;
    offsetAPO!: number;
    exportType!: ExportType;
    lvlCustomer!: ECustomerGroup;
    isDisabled?: boolean;
    salesOrgImports?: SalesOrgImportDto[] | undefined;

    constructor(data?: ISalesOrgDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.id = 0;
            this.deliveryBlock = "ZA";
            this.orderReason = "D51";
            this.isMatureForSAP = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : 0;
            this.fileCode = _data["fileCode"];
            this.compagnyCode = _data["compagnyCode"];
            this.sapCode = _data["sapCode"];
            this.description = _data["description"];
            this.docType = _data["docType"];
            this.deliveryBlock = _data["deliveryBlock"] !== undefined ? _data["deliveryBlock"] : "ZA";
            this.orderReason = _data["orderReason"] !== undefined ? _data["orderReason"] : "D51";
            this.isMatureForSAP = _data["isMatureForSAP"] !== undefined ? _data["isMatureForSAP"] : false;
            this.fixQuotationType = _data["fixQuotationType"];
            this.offsetAPO = _data["offsetAPO"];
            this.exportType = _data["exportType"];
            this.lvlCustomer = _data["lvlCustomer"];
            this.isDisabled = _data["isDisabled"];
            if (Array.isArray(_data["salesOrgImports"])) {
                this.salesOrgImports = [] as any;
                for (let item of _data["salesOrgImports"])
                    this.salesOrgImports!.push(SalesOrgImportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesOrgDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrgDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileCode"] = this.fileCode;
        data["compagnyCode"] = this.compagnyCode;
        data["sapCode"] = this.sapCode;
        data["description"] = this.description;
        data["docType"] = this.docType;
        data["deliveryBlock"] = this.deliveryBlock;
        data["orderReason"] = this.orderReason;
        data["isMatureForSAP"] = this.isMatureForSAP;
        data["fixQuotationType"] = this.fixQuotationType;
        data["offsetAPO"] = this.offsetAPO;
        data["exportType"] = this.exportType;
        data["lvlCustomer"] = this.lvlCustomer;
        data["isDisabled"] = this.isDisabled;
        if (Array.isArray(this.salesOrgImports)) {
            data["salesOrgImports"] = [];
            for (let item of this.salesOrgImports)
                data["salesOrgImports"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesOrgDto {
    id: number;
    fileCode: string;
    compagnyCode: string;
    sapCode: string;
    description: string;
    docType?: string | undefined;
    deliveryBlock: string;
    orderReason: string;
    isMatureForSAP: boolean;
    fixQuotationType?: string | undefined;
    offsetAPO: number;
    exportType: ExportType;
    lvlCustomer: ECustomerGroup;
    isDisabled?: boolean;
    salesOrgImports?: SalesOrgImportDto[] | undefined;
}

export class SalesOrgImport implements ISalesOrgImport {
    id?: number;
    isSuccess?: boolean;
    errorImportMessage?: string | undefined;
    lastImportDate?: Date;
    entityType?: string | undefined;
    salesOrgId?: number;
    salesOrg?: SalesOrg;

    constructor(data?: ISalesOrgImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSuccess = _data["isSuccess"];
            this.errorImportMessage = _data["errorImportMessage"];
            this.lastImportDate = _data["lastImportDate"] ? new Date(_data["lastImportDate"].toString()) : <any>undefined;
            this.entityType = _data["entityType"];
            this.salesOrgId = _data["salesOrgId"];
            this.salesOrg = _data["salesOrg"] ? SalesOrg.fromJS(_data["salesOrg"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SalesOrgImport {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrgImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSuccess"] = this.isSuccess;
        data["errorImportMessage"] = this.errorImportMessage;
        data["lastImportDate"] = this.lastImportDate ? this.lastImportDate.toISOString() : <any>undefined;
        data["entityType"] = this.entityType;
        data["salesOrgId"] = this.salesOrgId;
        data["salesOrg"] = this.salesOrg ? this.salesOrg.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISalesOrgImport {
    id?: number;
    isSuccess?: boolean;
    errorImportMessage?: string | undefined;
    lastImportDate?: Date;
    entityType?: string | undefined;
    salesOrgId?: number;
    salesOrg?: SalesOrg;
}

export class SalesOrgImportDto implements ISalesOrgImportDto {
    id?: number;
    isSuccess?: boolean;
    errorImportMessage?: string | undefined;
    lastImportDate?: Date;
    entityType?: string | undefined;
    salesOrgId?: number;

    constructor(data?: ISalesOrgImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSuccess = _data["isSuccess"];
            this.errorImportMessage = _data["errorImportMessage"];
            this.lastImportDate = _data["lastImportDate"] ? new Date(_data["lastImportDate"].toString()) : <any>undefined;
            this.entityType = _data["entityType"];
            this.salesOrgId = _data["salesOrgId"];
        }
    }

    static fromJS(data: any): SalesOrgImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrgImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSuccess"] = this.isSuccess;
        data["errorImportMessage"] = this.errorImportMessage;
        data["lastImportDate"] = this.lastImportDate ? this.lastImportDate.toISOString() : <any>undefined;
        data["entityType"] = this.entityType;
        data["salesOrgId"] = this.salesOrgId;
        return data; 
    }
}

export interface ISalesOrgImportDto {
    id?: number;
    isSuccess?: boolean;
    errorImportMessage?: string | undefined;
    lastImportDate?: Date;
    entityType?: string | undefined;
    salesOrgId?: number;
}

export class SelectedCMMF implements ISelectedCMMF {
    id?: number;
    cmmfId?: number;
    longCommercialCode?: string | undefined;
    productName?: string | undefined;
    cmmfGroup?: CMMFGroup;
    code?: string | undefined;
    quantity?: number;
    kamComment?: string | undefined;
    dpComment?: string | undefined;
    snpComment?: string | undefined;
    acceptSupply?: boolean;
    flagSupply?: boolean;
    buStatus?: EBUStatus;
    supplyDeadline?: Date | undefined;
    promotionId?: number;
    familyLevelOne?: string | undefined;
    plant?: string | undefined;

    constructor(data?: ISelectedCMMF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cmmfId = _data["cmmfId"];
            this.longCommercialCode = _data["longCommercialCode"];
            this.productName = _data["productName"];
            this.cmmfGroup = _data["cmmfGroup"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.kamComment = _data["kamComment"];
            this.dpComment = _data["dpComment"];
            this.snpComment = _data["snpComment"];
            this.acceptSupply = _data["acceptSupply"];
            this.flagSupply = _data["flagSupply"];
            this.buStatus = _data["buStatus"];
            this.supplyDeadline = _data["supplyDeadline"] ? new Date(_data["supplyDeadline"].toString()) : <any>undefined;
            this.promotionId = _data["promotionId"];
            this.familyLevelOne = _data["familyLevelOne"];
            this.plant = _data["plant"];
        }
    }

    static fromJS(data: any): SelectedCMMF {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedCMMF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cmmfId"] = this.cmmfId;
        data["longCommercialCode"] = this.longCommercialCode;
        data["productName"] = this.productName;
        data["cmmfGroup"] = this.cmmfGroup;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["kamComment"] = this.kamComment;
        data["dpComment"] = this.dpComment;
        data["snpComment"] = this.snpComment;
        data["acceptSupply"] = this.acceptSupply;
        data["flagSupply"] = this.flagSupply;
        data["buStatus"] = this.buStatus;
        data["supplyDeadline"] = this.supplyDeadline ? this.supplyDeadline.toISOString() : <any>undefined;
        data["promotionId"] = this.promotionId;
        data["familyLevelOne"] = this.familyLevelOne;
        data["plant"] = this.plant;
        return data; 
    }
}

export interface ISelectedCMMF {
    id?: number;
    cmmfId?: number;
    longCommercialCode?: string | undefined;
    productName?: string | undefined;
    cmmfGroup?: CMMFGroup;
    code?: string | undefined;
    quantity?: number;
    kamComment?: string | undefined;
    dpComment?: string | undefined;
    snpComment?: string | undefined;
    acceptSupply?: boolean;
    flagSupply?: boolean;
    buStatus?: EBUStatus;
    supplyDeadline?: Date | undefined;
    promotionId?: number;
    familyLevelOne?: string | undefined;
    plant?: string | undefined;
}

export class SelectedCMMFImportResult implements ISelectedCMMFImportResult {
    data?: SelectedCMMF[] | undefined;
    errors?: string[] | undefined;

    constructor(data?: ISelectedCMMFImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SelectedCMMF.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): SelectedCMMFImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedCMMFImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }
}

export interface ISelectedCMMFImportResult {
    data?: SelectedCMMF[] | undefined;
    errors?: string[] | undefined;
}

export class SnpMapping implements ISnpMapping {
    id?: number;
    familyLevelOne!: string;
    plant!: string;
    snpId!: number;
    snp?: UserInformations;
    minForRequest!: number;

    constructor(data?: ISnpMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.familyLevelOne = _data["familyLevelOne"];
            this.plant = _data["plant"];
            this.snpId = _data["snpId"];
            this.snp = _data["snp"] ? UserInformations.fromJS(_data["snp"]) : <any>undefined;
            this.minForRequest = _data["minForRequest"];
        }
    }

    static fromJS(data: any): SnpMapping {
        data = typeof data === 'object' ? data : {};
        let result = new SnpMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["familyLevelOne"] = this.familyLevelOne;
        data["plant"] = this.plant;
        data["snpId"] = this.snpId;
        data["snp"] = this.snp ? this.snp.toJSON() : <any>undefined;
        data["minForRequest"] = this.minForRequest;
        return data; 
    }
}

export interface ISnpMapping {
    id?: number;
    familyLevelOne: string;
    plant: string;
    snpId: number;
    snp?: UserInformations;
    minForRequest: number;
}

export class StatusChangeUpdate implements IStatusChangeUpdate {
    idPromotion?: number;
    newStatus?: EPromotionStatus;
    cancelReasonId?: number;

    constructor(data?: IStatusChangeUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPromotion = _data["idPromotion"];
            this.newStatus = _data["newStatus"];
            this.cancelReasonId = _data["cancelReasonId"];
        }
    }

    static fromJS(data: any): StatusChangeUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new StatusChangeUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPromotion"] = this.idPromotion;
        data["newStatus"] = this.newStatus;
        data["cancelReasonId"] = this.cancelReasonId;
        return data; 
    }
}

export interface IStatusChangeUpdate {
    idPromotion?: number;
    newStatus?: EPromotionStatus;
    cancelReasonId?: number;
}

export class UpdatePossibleDp implements IUpdatePossibleDp {
    id?: number;
    criticity?: number | undefined;
    dpComment?: string | undefined;
    listOfSelectedCMMF?: SelectedCMMF[] | undefined;
    kamId?: number | undefined;
    dpIds?: number[] | undefined;
    assistantKAMId?: number[] | undefined;
    isQuotationEnabled?: boolean;
    supplyDeadline?: Date | undefined;

    constructor(data?: IUpdatePossibleDp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.criticity = _data["criticity"];
            this.dpComment = _data["dpComment"];
            if (Array.isArray(_data["listOfSelectedCMMF"])) {
                this.listOfSelectedCMMF = [] as any;
                for (let item of _data["listOfSelectedCMMF"])
                    this.listOfSelectedCMMF!.push(SelectedCMMF.fromJS(item));
            }
            this.kamId = _data["kamId"];
            if (Array.isArray(_data["dpIds"])) {
                this.dpIds = [] as any;
                for (let item of _data["dpIds"])
                    this.dpIds!.push(item);
            }
            if (Array.isArray(_data["assistantKAMId"])) {
                this.assistantKAMId = [] as any;
                for (let item of _data["assistantKAMId"])
                    this.assistantKAMId!.push(item);
            }
            this.isQuotationEnabled = _data["isQuotationEnabled"];
            this.supplyDeadline = _data["supplyDeadline"] ? new Date(_data["supplyDeadline"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePossibleDp {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePossibleDp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["criticity"] = this.criticity;
        data["dpComment"] = this.dpComment;
        if (Array.isArray(this.listOfSelectedCMMF)) {
            data["listOfSelectedCMMF"] = [];
            for (let item of this.listOfSelectedCMMF)
                data["listOfSelectedCMMF"].push(item.toJSON());
        }
        data["kamId"] = this.kamId;
        if (Array.isArray(this.dpIds)) {
            data["dpIds"] = [];
            for (let item of this.dpIds)
                data["dpIds"].push(item);
        }
        if (Array.isArray(this.assistantKAMId)) {
            data["assistantKAMId"] = [];
            for (let item of this.assistantKAMId)
                data["assistantKAMId"].push(item);
        }
        data["isQuotationEnabled"] = this.isQuotationEnabled;
        data["supplyDeadline"] = this.supplyDeadline ? this.supplyDeadline.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePossibleDp {
    id?: number;
    criticity?: number | undefined;
    dpComment?: string | undefined;
    listOfSelectedCMMF?: SelectedCMMF[] | undefined;
    kamId?: number | undefined;
    dpIds?: number[] | undefined;
    assistantKAMId?: number[] | undefined;
    isQuotationEnabled?: boolean;
    supplyDeadline?: Date | undefined;
}

export class UpdatePossibleSnp implements IUpdatePossibleSnp {
    id?: number;
    listOfSelectedCMMF?: SelectedCMMF[] | undefined;

    constructor(data?: IUpdatePossibleSnp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["listOfSelectedCMMF"])) {
                this.listOfSelectedCMMF = [] as any;
                for (let item of _data["listOfSelectedCMMF"])
                    this.listOfSelectedCMMF!.push(SelectedCMMF.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePossibleSnp {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePossibleSnp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.listOfSelectedCMMF)) {
            data["listOfSelectedCMMF"] = [];
            for (let item of this.listOfSelectedCMMF)
                data["listOfSelectedCMMF"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdatePossibleSnp {
    id?: number;
    listOfSelectedCMMF?: SelectedCMMF[] | undefined;
}

export class UserInformationDto implements IUserInformationDto {
    id?: number;
    email?: string | undefined;
    roleModelId?: number | undefined;
    keyUser?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    readonly fullName?: string | undefined;
    desactivated?: boolean;
    isSuperAdmin?: boolean;
    role?: EUserRole;

    constructor(data?: IUserInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.roleModelId = _data["roleModelId"];
            this.keyUser = _data["keyUser"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
            this.desactivated = _data["desactivated"];
            this.isSuperAdmin = _data["isSuperAdmin"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["roleModelId"] = this.roleModelId;
        data["keyUser"] = this.keyUser;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["desactivated"] = this.desactivated;
        data["isSuperAdmin"] = this.isSuperAdmin;
        data["role"] = this.role;
        return data; 
    }
}

export interface IUserInformationDto {
    id?: number;
    email?: string | undefined;
    roleModelId?: number | undefined;
    keyUser?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    desactivated?: boolean;
    isSuperAdmin?: boolean;
    role?: EUserRole;
}

export class UserInformations implements IUserInformations {
    id?: number;
    email?: string | undefined;
    roleModelId?: number | undefined;
    roleModel?: UserRole;
    keyUser?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    desactivated?: boolean;
    isSuperAdmin?: boolean;
    readonly fullName?: string | undefined;
    readonly promotions?: Promotion[] | undefined;
    promotionsKAM?: Promotion[] | undefined;
    createdPromotionList?: Promotion[] | undefined;
    promotionsLocked?: PromotionLock[] | undefined;
    userSalesOrg?: UserSalesOrg[] | undefined;
    promotionKamAssistants?: PromotionKamAssistant[] | undefined;
    promotionDemandPlanners?: PromotionDemandPlanner[] | undefined;
    delegatorDelegations?: Delegation[] | undefined;
    surrogateDelegations?: Delegation[] | undefined;
    supplyNetworkPlannerMappings?: SnpMapping[] | undefined;
    promotionModificationHistory?: PromotionHistory[] | undefined;
    role?: EUserRole;

    constructor(data?: IUserInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.roleModelId = _data["roleModelId"];
            this.roleModel = _data["roleModel"] ? UserRole.fromJS(_data["roleModel"]) : <any>undefined;
            this.keyUser = _data["keyUser"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.desactivated = _data["desactivated"];
            this.isSuperAdmin = _data["isSuperAdmin"];
            (<any>this).fullName = _data["fullName"];
            if (Array.isArray(_data["promotions"])) {
                (<any>this).promotions = [] as any;
                for (let item of _data["promotions"])
                    (<any>this).promotions!.push(Promotion.fromJS(item));
            }
            if (Array.isArray(_data["promotionsKAM"])) {
                this.promotionsKAM = [] as any;
                for (let item of _data["promotionsKAM"])
                    this.promotionsKAM!.push(Promotion.fromJS(item));
            }
            if (Array.isArray(_data["createdPromotionList"])) {
                this.createdPromotionList = [] as any;
                for (let item of _data["createdPromotionList"])
                    this.createdPromotionList!.push(Promotion.fromJS(item));
            }
            if (Array.isArray(_data["promotionsLocked"])) {
                this.promotionsLocked = [] as any;
                for (let item of _data["promotionsLocked"])
                    this.promotionsLocked!.push(PromotionLock.fromJS(item));
            }
            if (Array.isArray(_data["userSalesOrg"])) {
                this.userSalesOrg = [] as any;
                for (let item of _data["userSalesOrg"])
                    this.userSalesOrg!.push(UserSalesOrg.fromJS(item));
            }
            if (Array.isArray(_data["promotionKamAssistants"])) {
                this.promotionKamAssistants = [] as any;
                for (let item of _data["promotionKamAssistants"])
                    this.promotionKamAssistants!.push(PromotionKamAssistant.fromJS(item));
            }
            if (Array.isArray(_data["promotionDemandPlanners"])) {
                this.promotionDemandPlanners = [] as any;
                for (let item of _data["promotionDemandPlanners"])
                    this.promotionDemandPlanners!.push(PromotionDemandPlanner.fromJS(item));
            }
            if (Array.isArray(_data["delegatorDelegations"])) {
                this.delegatorDelegations = [] as any;
                for (let item of _data["delegatorDelegations"])
                    this.delegatorDelegations!.push(Delegation.fromJS(item));
            }
            if (Array.isArray(_data["surrogateDelegations"])) {
                this.surrogateDelegations = [] as any;
                for (let item of _data["surrogateDelegations"])
                    this.surrogateDelegations!.push(Delegation.fromJS(item));
            }
            if (Array.isArray(_data["supplyNetworkPlannerMappings"])) {
                this.supplyNetworkPlannerMappings = [] as any;
                for (let item of _data["supplyNetworkPlannerMappings"])
                    this.supplyNetworkPlannerMappings!.push(SnpMapping.fromJS(item));
            }
            if (Array.isArray(_data["promotionModificationHistory"])) {
                this.promotionModificationHistory = [] as any;
                for (let item of _data["promotionModificationHistory"])
                    this.promotionModificationHistory!.push(PromotionHistory.fromJS(item));
            }
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserInformations {
        data = typeof data === 'object' ? data : {};
        let result = new UserInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["roleModelId"] = this.roleModelId;
        data["roleModel"] = this.roleModel ? this.roleModel.toJSON() : <any>undefined;
        data["keyUser"] = this.keyUser;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["desactivated"] = this.desactivated;
        data["isSuperAdmin"] = this.isSuperAdmin;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionsKAM)) {
            data["promotionsKAM"] = [];
            for (let item of this.promotionsKAM)
                data["promotionsKAM"].push(item.toJSON());
        }
        if (Array.isArray(this.createdPromotionList)) {
            data["createdPromotionList"] = [];
            for (let item of this.createdPromotionList)
                data["createdPromotionList"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionsLocked)) {
            data["promotionsLocked"] = [];
            for (let item of this.promotionsLocked)
                data["promotionsLocked"].push(item.toJSON());
        }
        if (Array.isArray(this.userSalesOrg)) {
            data["userSalesOrg"] = [];
            for (let item of this.userSalesOrg)
                data["userSalesOrg"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionKamAssistants)) {
            data["promotionKamAssistants"] = [];
            for (let item of this.promotionKamAssistants)
                data["promotionKamAssistants"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionDemandPlanners)) {
            data["promotionDemandPlanners"] = [];
            for (let item of this.promotionDemandPlanners)
                data["promotionDemandPlanners"].push(item.toJSON());
        }
        if (Array.isArray(this.delegatorDelegations)) {
            data["delegatorDelegations"] = [];
            for (let item of this.delegatorDelegations)
                data["delegatorDelegations"].push(item.toJSON());
        }
        if (Array.isArray(this.surrogateDelegations)) {
            data["surrogateDelegations"] = [];
            for (let item of this.surrogateDelegations)
                data["surrogateDelegations"].push(item.toJSON());
        }
        if (Array.isArray(this.supplyNetworkPlannerMappings)) {
            data["supplyNetworkPlannerMappings"] = [];
            for (let item of this.supplyNetworkPlannerMappings)
                data["supplyNetworkPlannerMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionModificationHistory)) {
            data["promotionModificationHistory"] = [];
            for (let item of this.promotionModificationHistory)
                data["promotionModificationHistory"].push(item.toJSON());
        }
        data["role"] = this.role;
        return data; 
    }
}

export interface IUserInformations {
    id?: number;
    email?: string | undefined;
    roleModelId?: number | undefined;
    roleModel?: UserRole;
    keyUser?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    desactivated?: boolean;
    isSuperAdmin?: boolean;
    fullName?: string | undefined;
    promotions?: Promotion[] | undefined;
    promotionsKAM?: Promotion[] | undefined;
    createdPromotionList?: Promotion[] | undefined;
    promotionsLocked?: PromotionLock[] | undefined;
    userSalesOrg?: UserSalesOrg[] | undefined;
    promotionKamAssistants?: PromotionKamAssistant[] | undefined;
    promotionDemandPlanners?: PromotionDemandPlanner[] | undefined;
    delegatorDelegations?: Delegation[] | undefined;
    surrogateDelegations?: Delegation[] | undefined;
    supplyNetworkPlannerMappings?: SnpMapping[] | undefined;
    promotionModificationHistory?: PromotionHistory[] | undefined;
    role?: EUserRole;
}

export class UserPossible implements IUserPossible {
    id?: string | undefined;
    email?: string | undefined;
    displayName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IUserPossible) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): UserPossible {
        data = typeof data === 'object' ? data : {};
        let result = new UserPossible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data; 
    }
}

export interface IUserPossible {
    id?: string | undefined;
    email?: string | undefined;
    displayName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class UserRole implements IUserRole {
    id?: number;
    name!: string;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IUserRole {
    id?: number;
    name: string;
}

export class UserSalesOrg implements IUserSalesOrg {
    userInformationsId?: number;
    userInformation?: UserInformations;
    salesOrgId?: number;
    salesOrg?: SalesOrg;

    constructor(data?: IUserSalesOrg) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userInformationsId = _data["userInformationsId"];
            this.userInformation = _data["userInformation"] ? UserInformations.fromJS(_data["userInformation"]) : <any>undefined;
            this.salesOrgId = _data["salesOrgId"];
            this.salesOrg = _data["salesOrg"] ? SalesOrg.fromJS(_data["salesOrg"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSalesOrg {
        data = typeof data === 'object' ? data : {};
        let result = new UserSalesOrg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userInformationsId"] = this.userInformationsId;
        data["userInformation"] = this.userInformation ? this.userInformation.toJSON() : <any>undefined;
        data["salesOrgId"] = this.salesOrgId;
        data["salesOrg"] = this.salesOrg ? this.salesOrg.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserSalesOrg {
    userInformationsId?: number;
    userInformation?: UserInformations;
    salesOrgId?: number;
    salesOrg?: SalesOrg;
}

export class Worklist implements IWorklist {
    id?: number;
    promotionName?: string | undefined;
    status?: PromotionStatusDto;
    quotationNumber?: string | undefined;
    customer?: CustomerDto;
    kam?: UserInformationDto;
    sellInStart?: Date | undefined;
    sellInEnd?: Date | undefined;
    sellOutStart?: Date | undefined;
    sellOutEnd?: Date | undefined;
    supplyDeadline?: Date | undefined;
    creationDate?: Date;
    modificationDate?: Date;
    salesOrg?: SalesOrgDto;
    demandPlannerList?: UserInformationDto[] | undefined;
    lockUser?: UserInformationDto;
    listOfSelectedCMMF?: SelectedCMMF[] | undefined;

    constructor(data?: IWorklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.promotionName = _data["promotionName"];
            this.status = _data["status"] ? PromotionStatusDto.fromJS(_data["status"]) : <any>undefined;
            this.quotationNumber = _data["quotationNumber"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.kam = _data["kam"] ? UserInformationDto.fromJS(_data["kam"]) : <any>undefined;
            this.sellInStart = _data["sellInStart"] ? new Date(_data["sellInStart"].toString()) : <any>undefined;
            this.sellInEnd = _data["sellInEnd"] ? new Date(_data["sellInEnd"].toString()) : <any>undefined;
            this.sellOutStart = _data["sellOutStart"] ? new Date(_data["sellOutStart"].toString()) : <any>undefined;
            this.sellOutEnd = _data["sellOutEnd"] ? new Date(_data["sellOutEnd"].toString()) : <any>undefined;
            this.supplyDeadline = _data["supplyDeadline"] ? new Date(_data["supplyDeadline"].toString()) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>undefined;
            this.salesOrg = _data["salesOrg"] ? SalesOrgDto.fromJS(_data["salesOrg"]) : <any>undefined;
            if (Array.isArray(_data["demandPlannerList"])) {
                this.demandPlannerList = [] as any;
                for (let item of _data["demandPlannerList"])
                    this.demandPlannerList!.push(UserInformationDto.fromJS(item));
            }
            this.lockUser = _data["lockUser"] ? UserInformationDto.fromJS(_data["lockUser"]) : <any>undefined;
            if (Array.isArray(_data["listOfSelectedCMMF"])) {
                this.listOfSelectedCMMF = [] as any;
                for (let item of _data["listOfSelectedCMMF"])
                    this.listOfSelectedCMMF!.push(SelectedCMMF.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Worklist {
        data = typeof data === 'object' ? data : {};
        let result = new Worklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["promotionName"] = this.promotionName;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["quotationNumber"] = this.quotationNumber;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["kam"] = this.kam ? this.kam.toJSON() : <any>undefined;
        data["sellInStart"] = this.sellInStart ? this.sellInStart.toISOString() : <any>undefined;
        data["sellInEnd"] = this.sellInEnd ? this.sellInEnd.toISOString() : <any>undefined;
        data["sellOutStart"] = this.sellOutStart ? this.sellOutStart.toISOString() : <any>undefined;
        data["sellOutEnd"] = this.sellOutEnd ? this.sellOutEnd.toISOString() : <any>undefined;
        data["supplyDeadline"] = this.supplyDeadline ? this.supplyDeadline.toISOString() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        data["salesOrg"] = this.salesOrg ? this.salesOrg.toJSON() : <any>undefined;
        if (Array.isArray(this.demandPlannerList)) {
            data["demandPlannerList"] = [];
            for (let item of this.demandPlannerList)
                data["demandPlannerList"].push(item.toJSON());
        }
        data["lockUser"] = this.lockUser ? this.lockUser.toJSON() : <any>undefined;
        if (Array.isArray(this.listOfSelectedCMMF)) {
            data["listOfSelectedCMMF"] = [];
            for (let item of this.listOfSelectedCMMF)
                data["listOfSelectedCMMF"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorklist {
    id?: number;
    promotionName?: string | undefined;
    status?: PromotionStatusDto;
    quotationNumber?: string | undefined;
    customer?: CustomerDto;
    kam?: UserInformationDto;
    sellInStart?: Date | undefined;
    sellInEnd?: Date | undefined;
    sellOutStart?: Date | undefined;
    sellOutEnd?: Date | undefined;
    supplyDeadline?: Date | undefined;
    creationDate?: Date;
    modificationDate?: Date;
    salesOrg?: SalesOrgDto;
    demandPlannerList?: UserInformationDto[] | undefined;
    lockUser?: UserInformationDto;
    listOfSelectedCMMF?: SelectedCMMF[] | undefined;
}

/** 0 = ASKED 1 = APPROVED 2 = DENIED */
export enum EBUStatus {
    ASKED = 0,
    APPROVED = 1,
    DENIED = 2,
}

/** 0 = LOCAL_HIERARCHY_NODE 1 = SOLD_TO_PARTY_COMMON 2 = SOLD_TO_PARTY_LOCAL 3 = LOCAL_CUSTOMER_SOLD_TO_PARTY 4 = COMMON_HIERARCHY_NODES 5 = SHIP_TO_PARTY_COMMON 6 = SHIP_TO_PARTY_LOCAL 7 = LOCAL_CUSTOMER_SHIP_TO_PARTY 8 = BUSINESS_ONE */
export enum ECustomerGroup {
    LOCAL_HIERARCHY_NODE = 0,
    SOLD_TO_PARTY_COMMON = 1,
    SOLD_TO_PARTY_LOCAL = 2,
    LOCAL_CUSTOMER_SOLD_TO_PARTY = 3,
    COMMON_HIERARCHY_NODES = 4,
    SHIP_TO_PARTY_COMMON = 5,
    SHIP_TO_PARTY_LOCAL = 6,
    LOCAL_CUSTOMER_SHIP_TO_PARTY = 7,
    BUSINESS_ONE = 8,
}

/** 0 = NORMAL 1 = BU */
export enum EDownloadPromotionType {
    NORMAL = 0,
    BU = 1,
}

/** 0 = MY_WORKLIST 1 = MY_PROMOTION 2 = ALL */
export enum EPromotionListOption {
    MY_WORKLIST = 0,
    MY_PROMOTION = 1,
    ALL = 2,
}

/** 1 = NEW 2 = DRAFT 3 = PREVALIDATED 4 = REWORK 5 = CHANGED 6 = APPROVED 8 = UNDONE 9 = CANCELLED 11 = BU_CHECK */
export enum EPromotionStatus {
    NEW = 1,
    DRAFT = 2,
    PREVALIDATED = 3,
    REWORK = 4,
    CHANGED = 5,
    APPROVED = 6,
    UNDONE = 8,
    CANCELLED = 9,
    BU_CHECK = 11,
}

/** 0 = PRICE_REDUCTION 1 = REBATES 2 = SLOB_EXHAUSTION 3 = PURE_PLAYER */
export enum EPromotionType {
    PRICE_REDUCTION = 0,
    REBATES = 1,
    SLOB_EXHAUSTION = 2,
    PURE_PLAYER = 3,
}

/** 0 = UNDEFINED 1 = ADMINISTRATOR 2 = KEY_ACCOUNT_MANAGER 3 = KAM_ASSISTANT 4 = DEMAND_PLANNER 5 = IT_LOCAL 6 = SUPPLY_NETWORK_PLANNER 7 = REPORTING */
export enum EUserRole {
    UNDEFINED = 0,
    ADMINISTRATOR = 1,
    KEY_ACCOUNT_MANAGER = 2,
    KAM_ASSISTANT = 3,
    DEMAND_PLANNER = 4,
    IT_LOCAL = 5,
    SUPPLY_NETWORK_PLANNER = 6,
    REPORTING = 7,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}